import { render, staticRenderFns } from "./BlogList.vue?vue&type=template&id=955b80e0&"
import script from "./BlogList.vue?vue&type=script&lang=ts&"
export * from "./BlogList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports